import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ComponentPageTitle } from '../../page-title/page-title.component';
import { AppServiceService } from '../../services/app-service.service';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { CreateCampanaComponent } from 'src/app/home/campana-admin/create-campana/create-campana.component';
// import { ModifyCampanaComponent } from 'src/app/home/modify-campana/modify-campana.component';
import { CreateScheduleComponent } from 'src/app/home/create-schedule/create-schedule.component';
import { CreateAlarmaComponent } from 'src/app/home/create-alarma/create-alarma.component';
import { CreateCriterioComponent } from 'src/app/home/create-criterio/create-criterio.component';
import { GatewayService } from 'src/app/gateway.service';
import { ConfigService } from 'src/app/services/config.service';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { CreateCicloComponent } from 'src/app/home/create-ciclo/create-ciclo.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
import { PasswordnewComponent } from 'src/app/login/passwordnew/passwordnew.component';
import { EditContratasComponent } from './edit-contratas/edit-contratas.component';
import { DlgFiltersComponent } from './dlg-filters/dlg-filters.component';
import { FiltrosRepcampanaComponent } from 'src/app/home/filtros-repcampana/filtros-repcampana.component';
// import { DuplicarCampanaComponent } from './duplicar-campana/duplicar-campana.component';
import * as AWS from 'aws-sdk';

@Component({
	selector: 'app-campana-admin',
	templateUrl: './campana-admin.component.html',
	styleUrls: ['./campana-admin.component.scss']
})
export class CampanaAdminComponent implements OnInit, OnDestroy {

	private destroy$ = new Subject<void>();
	private s3: AWS.S3;

	estados = [
		{ id: 1, nombre: 'TOTAL CLIENTES', cantidad: 0, descripcion: `total de clientes.` },
		{ id: 2, nombre: 'GESTIONADOS', cantidad: 0, descripcion: `cantidad de clientes gestionados.` },
		{ id: 3, nombre: 'AGENDADOS', cantidad: 0, descripcion: `cantidad de clientes que tienen una cita agendada.` },
		{ id: 4, nombre: 'PENDIENTES DE GESTIÓN', cantidad: 0, descripcion: `cantidad de clientes que aún no tienen una gestión.` },
		{ id: 5, nombre: 'RECUPERADOS', cantidad: 0, descripcion: `cantidad de clientes que tienen una cita exitosa.` },
	]
	idcampanaselect = 0;

	// campanaColumns: string[] = ['NOMBREEJE', 'NOMBRE', 'MEDIO', 'VIGENCIAINICIAL', 'VIGENCIAFINAL', 'PAIS', 'ACCION'];
	//campanaColumns: string[] = ['NOMBREEJE', 'NOMBRE', 'MEDIO', 'VIGENCIAINICIAL', 'VIGENCIAFINAL', 'ACCION'];
	// campanaColumns: string[] = ['NOMBREEJE', 'NOMBRE', 'MEDIO', 'ESTADO', 'CREACION', 'VIGENCIAINICIAL', 'VIGENCIAFINAL', 'CANTCLIENT', 'ACCION'];
	campanaColumns: string[] = ['NOMBREEJE', 'NOMBRE', 'MEDIO', 'ESTADO', 'CREACION', 'VIGENCIAINICIAL', 'VIGENCIAFINAL', 'CANTCLIENT', 'FECHAUPDATE', 'ACCION'];
	dataSource = new MatTableDataSource<any>([]);
	FILTER: string = '';
	resultsLength: number = 0;
	pageSize = 10;
	private subscription: Subscription;
	private subscriptioncreate: Subscription;
	private subscriptionpais: Subscription;
	idpais;
	pageEvent: PageEvent;
	public actpage: number = 0;
	activo = 1;
	selectedRow: any = null;

	constructor(
		private router: Router,
		private snackbar: MatSnackBar,
		private gateway: GatewayService,
		public pageTitle: ComponentPageTitle,
		public _appservice: AppServiceService,
		public _busqueda: BusquedaService,
		public _create: CreateService,
		private dialog: MatDialog,
		public _filtroPais: FiltroPaisService,
		private localSave: LocalSaveService,
		private spinner: NgxSpinnerService,
		private configService: ConfigService
	) {
		const awsCfg = this.configService.getAwsConfig();
		AWS.config.update({
			accessKeyId: awsCfg ? awsCfg.accessKeyId : '',
			secretAccessKey: awsCfg ? awsCfg.secret : '',
			region: (awsCfg ? awsCfg.region : '') || 'us-east-1'
		});
		this.s3 = new AWS.S3({
			params: {
				Bucket: 'socialmanager/importleads'
			}
		});
	}

	@ViewChild('campanaTable') campanaTable: any;

	ngOnInit() {

		const user = this.localSave.get('usuarioPGV');
		// alert(user.idrol)
		if (user.idrol == 1) {
			this.router.navigate(['/home/campana']);
		}
		else if (user && user.idrol == 1) {
			this.router.navigate(['/home/administrador']);
		}
		else if (user && user.idrol == 16) {
			// this.router.navigate(['/home/campanaadmin']);
		}
		else if (user && user.idrol == 17) {
			this.router.navigate(['/homeagente/botonera']);
		} else {
			this.router.navigate(['/home']);
		}
		this.idpais = this.localSave.get('pais');
		this.get(0);
		this.pageTitle.title = 'Campañas';
		// this.loadUsuarios();
		this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.filtrarcampana(res.filtro);
			});
		this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				// console.log(res);
				this.createCampana();
			});
		this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				// console.log(res);
				this.idpais = res.IDPAIS;
				this.get(0);
			}
		);
	}

	filtrarxEstado(estado: any) {
		// this.snackbar.open(`Estado: ${estado.id}`, 'Cerrar', { duration: 3000, });
		this.activo = estado.id;
		this.get(this.actpage);
	}

	isSelected(row: any): boolean {
		return this.selectedRow === row;
	}

	getTotalesClientesxCampana(campana: any) {
		this.idcampanaselect = campana.idcampana;

	}

	onRowClick(row: any): void {
		if (this.selectedRow === row) {
			this.selectedRow = null;
			this.gateway.get('gettotalescampanasadmin', { IDADMINISTRADOR: this.localSave.get('usuarioPGV').IDU, IDCAMPANAPADRE: null, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result: any) => {
				if (result.length > 0) {
					this.estados[0].cantidad = result[0].TotalClientes;
					this.estados[1].cantidad = result[0].TotalGestionados;
					this.estados[2].cantidad = result[0].TotalAgendados;
					this.estados[3].cantidad = result[0].TotalPendientes;
					this.estados[4].cantidad = result[0].TotalCitasExitosas;
				}
			});
		} else {
			// Seleccionar el nuevo registro
			this.selectedRow = row;
			this.gateway.get('gettotalescampanasadmin', { IDADMINISTRADOR: null, IDCAMPANAPADRE: row.idcampana, IDAREA: null }).then((result: any) => {
				if (result.length > 0) {
					this.estados[0].cantidad = result[0].TotalClientes;
					this.estados[1].cantidad = result[0].TotalGestionados;
					this.estados[2].cantidad = result[0].TotalAgendados;
					this.estados[3].cantidad = result[0].TotalPendientes;
					this.estados[4].cantidad = result[0].TotalCitasExitosas;
				}
			});
		}
	}

	// ============== FILTRO ==============
	filter = '';
	public keyDownFunction(event) {
		if (event.keyCode == 13) {
			this.filtrogeneral();
		} else if (event.keyCode == 8 && this.filter == '') {
			this.filtrogeneral();
		}
	}
	public filtrogeneral() {
		this._busqueda.notificarBusqueda({ filtro: this.filter });
	}

	ngAfterViewInit() {
		// console.log(this.localSave.get('nuevoUserPass'))

		if (this.localSave.get('nuevoUserPass') == 0) {
			setTimeout(() => {
				this.openPassword();
			})

		}
	}

	get(page) {
		this.idcampanaselect = 0;
		this.gateway.get('gettotalescampanasadmin', { IDADMINISTRADOR: this.localSave.get('usuarioPGV').IDU, IDCAMPANAPADRE: null, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result: any) => {
			if (result.length > 0) {
				this.estados[0].cantidad = result[0].TotalClientes;
				this.estados[1].cantidad = result[0].TotalGestionados;
				this.estados[2].cantidad = result[0].TotalAgendados;
				this.estados[3].cantidad = result[0].TotalPendientes;
				this.estados[4].cantidad = result[0].TotalCitasExitosas;
			}
		});

		let params = { ACTIVO: this.activo, NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais, IDADMINISTRADOR: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA };
		// console.log(params);
		this.spinner.show();
		this.gateway.get('getcampanaadmin', params).then((result: any) => {
			const campanias = result.rows;
			if (campanias.length > 0) {
				campanias.forEach(campania => {
					// console.log(campania);
					campania.vigenciainicial = new Date(campania.vigenciainicial);
					campania.vigenciafinal = new Date(campania.vigenciafinal);
				});
				//this.dataSource = new MatTableDataSource(campanias);
			}
			this.dataSource = new MatTableDataSource(campanias);

			this.gateway.get('getcampanaadmincount', params).then((result: any) => {
				//console.log(result.rows);
				this.resultsLength = result.rows[0].total;

				// this.gateway.get('getcampanasemaforo', params).then((result: any) => {
				// 	let resultado = result.rows[0];
				// 	this.estados[0].cantidad = resultado.campanas_activas + resultado.campanas_no_activas;
				// 	this.estados[1].cantidad = resultado.campanas_activas;
				// 	this.estados[2].cantidad = resultado.campanas_en_curso;
				// 	this.estados[3].cantidad = resultado.campanas_no_activas;
				this.spinner.hide();
				// });

			});
		}
		).catch(function (e) {
		});
	}
	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
		this.subscription.unsubscribe();
		this.subscriptioncreate.unsubscribe();
		this.subscriptionpais.unsubscribe();
	}

	createCampana() {
		const dialogRef = this.dialog.open(CreateCampanaComponent, {
			width: '80%',
			height: '94%',
			data: { IDPAIS: this.idpais, title: 'Crear ' },
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			// console.log('The dialog was closed');
			this.get(this.actpage);
		});
	}

	cambioElementos(event?: PageEvent) {
		this.actpage = event.pageIndex;
		this.get(event.pageIndex);
	}

	addSchedule(campana) {

		this.localSave.set('campana', campana.IDCAMPANA);
		const dialogRef = this.dialog.open(CreateScheduleComponent, {
			maxWidth: '90vw',
			width: '620px',
			minHeight: '30vh',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			//console.log('The dialog was closed');
		});
	}

	editarCamapana(campana, title) {
		campana['IDPAIS'] = this.idpais;
		campana['title'] = title
		this.localSave.set('campana', campana.idcampana);
		const dialogRef = this.dialog.open(CreateCampanaComponent, {
			width: '80%',
			height: '94%',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			//console.log('The dialog was closed');
			//if (result) {
			this.get(this.actpage);
			//}
		});
	}

	crearCampanaXcontrata(element) {
		const dialogRef = this.dialog.open(ConfirmacionComponent, {
			disableClose: true,
			width: '500px',
			maxHeight: '460px',
			// height: '400px',
			data: { operacion: 'crearcampanaxcontrata', msg: 'replicar la campaña para cada contrata', id: { IDCAMPANA: element.idcampana, ...element } }
		});

		dialogRef.afterClosed().subscribe(() => {
			if (this.campanaTable && this.campanaTable.campanapaginator) { this.campanaTable.campanapaginator.firstPage(); }

			this.gateway.get('distribuirclientes', { IDCAMPANA: element.idcampana }).then((result: any) => { this.get(0); }).catch(function (e) { this.get(0); });
		});
	}

	editarCampanaXcontrata(element) {
		const dialogRef = this.dialog.open(EditContratasComponent, {
			maxWidth: '90vw',
			width: '620px',
			minHeight: '55vh',
			maxHeight: '70vh',
			data: {
				operacion: 'Editar',
				tipologia: { IDPAIS: this.idpais, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA },
				campana: element
			},
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(() => {
			if (this.campanaTable && this.campanaTable.campanapaginator) { this.campanaTable.campanapaginator.firstPage(); }

			// this.gateway.get('distribuirclientes', { IDCAMPANA: element.idcampana }).then((result: any) => { this.get(0); }).catch(function (e) { this.get(0); });
		});
	}

	editarFiltrosdeClientes(element) {
		const dialogRef = this.dialog.open(DlgFiltersComponent, {
			width: '640px',
			minHeight: '35vh',
			maxHeight: '35vh',
			data: {
				operacion: 'Editar',
				tipologia: { IDPAIS: this.idpais, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA },
				campana: element
			},
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(() => {
			if (this.campanaTable && this.campanaTable.campanapaginator) { this.campanaTable.campanapaginator.firstPage(); }
			// this.gateway.get('distribuirclientes', { IDCAMPANA: element.idcampana }).then((result: any) => { this.get(0); }).catch(function (e) { this.get(0); });
		});
	}

	addAlarm(campana) {

		this.localSave.set('campana', campana.IDCAMPANA);
		const dialogRef = this.dialog.open(CreateAlarmaComponent, {
			autoFocus: false,
			maxWidth: '90vw',
			width: '620px',
			minHeight: '30vh',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			// console.log('The dialog was closed');
		});
	}

	addCiclo(campana) {

		this.localSave.set('campana', campana.IDCAMPANA);
		const dialogRef = this.dialog.open(CreateCicloComponent, {
			autoFocus: false,
			maxWidth: '90vw',
			width: '620px',
			minHeight: '50vh',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			// console.log('The dialog was closed');
		});
	}

	addCriterio(campana) {

		this.localSave.set('campana', campana.IDCAMPANA);
		const dialogRef = this.dialog.open(CreateCriterioComponent, {
			autoFocus: false,
			maxWidth: '90vw',
			width: '620px',
			minHeight: '30vh',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			// console.log('The dialog was closed');
		});
	}

	delete(element) {
		//console.log(element)

		const dialogRef = this.dialog.open(ConfirmacionComponent, {
			disableClose: true,
			width: '300px',
			data: { operacion: 'deletecampana', id: { IDCAMPANA: element.idcampana } }
		});

		dialogRef.afterClosed().subscribe(() => {
			if (this.campanaTable && this.campanaTable.campanapaginator) { this.campanaTable.campanapaginator.firstPage(); }
			this.get(0);
		});
	}

	filtrarcampana(data) {
		this.FILTER = data;
		this.get(0);
	}

	// exportar(campana) {
	// this.spinner.show();
	// 

	// 	//console.log('ASDF');
	// 	console.log(campana.IDCAMPANA);
	// 	this.gateway.get('exportarlista', { IDCAMPANA: campana.IDCAMPANA }).then(

	exportar(campana) {
		this.spinner.show();
		this.gateway.get('exportarlistaadmincount', { IDCAMPANA: campana.idcampana }).then(
			(data: any) => {
				if (data.rows[0].cantidad > 0) {
					this.prepararinformacion(campana, data.rows[0].cantidad, 0, null);
				} else {
					this.snackbar.open('No hay clientes para esta campaña.', 'Cerrar', { duration: 3000, });
					this.spinner.hide();
				}
			}
		);
	}

	exportar_lista(campana) {
		const dialogRef = this.dialog.open(FiltrosRepcampanaComponent, {
			disableClose: true,
			width: '700px',
			// height: '300px',
			data: { campana: campana }
		});

		dialogRef.afterClosed().subscribe((resp) => {
			if (resp.valid) {
				const filtros = resp.result;
			}
		});
	}

	// =================================================================================================================
	// ========================================= CARGAR ARCHIVO XLSX ===================================================
	// =================================================================================================================
	public file; valor;
	openInput(campana) {
		this.localSave.set('campana', campana.idcampana);
		document.getElementById("fileInput100").click();
	}

	ObtenerArchivoCarga(event) {
		this.file = event.target.files[0];
		this.valor = this.file.name;
		if (typeof (this.file != "undefined")) {
			this.cargarLista();
		}
	}

	params: any;
	cargarLista() {
		this.spinner.show();
		const reader: FileReader = new FileReader();
		reader.onload = (e: any) => {
			/* read workbook */
			const bstr: string = e.target.result;
			const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
			/* grab first sheet */
			const wsname: string = wb.SheetNames[0];
			const ws: XLSX.WorkSheet = wb.Sheets[wsname];
			/* save data */
			const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
			// (<HTMLInputElement>document.getElementById('fileInput100')).value = null;

			let filename = Date.now() + '_' + this.valor;
			this.params = {
				Key: filename,
				Body: this.file,
				ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				ACL: 'public-read'
			};

			this.s3.upload(this.params, function (err, data) {
				if (err) {
				} else {
					(<HTMLInputElement>document.getElementById('fileInput100')).value = null;
				}
			});

			this.loadlistxls(dataexcel, ("https://s3.amazonaws.com/socialmanager/importleads/" + filename).trim(), this.valor);
		};
		reader.readAsBinaryString(this.file);
	}

	async loadlistxls(data, urlfinal, nombrearchivo) {
		this.spinner.show();
		let keys = data.splice(0, 1)[0];
		// console.log('keys:');
		// console.log(keys);
		// console.log('data:');
		// console.log(data);
		let dataConvert: any = this.convertirArreglo(data, keys);
		if (dataConvert.length) {
			this.snackbar.open('Iniciado: el proceso a comenzado.', 'Cerrar', { duration: 3000, });
		} else {
			this.spinner.hide();
			return;
		}

		const totaldatos = dataConvert;
		const cantini = dataConvert.length;
		dataConvert = dataConvert.filter(gestion => gestion.cc_campaign_id == this.localSave.get('campana'));
		const cantfin = dataConvert.length;
		let cantidad_insertados = 0;

		sendLista(0, this.gateway, this.localSave.get('campana'), this.spinner, this.snackbar, urlfinal, nombrearchivo, totaldatos, this);
		function sendLista(cantidad, gatew, idcampana, localspinner, localsnack, urlfinal, nombrearchivo, totaldatos, this2) {
			const that = this2;
			let auxarr = [];
			auxarr = dataConvert.slice(cantidad, cantidad + 100);

			gatew.save('insert_datos_gestiones', { DATOS: auxarr, IDCAMPANA: idcampana, NOMBRE: nombrearchivo, CONTENIDO: totaldatos, CONTENIDO_FILTRADO: dataConvert, URLFINAL: urlfinal, INICIO: cantidad }).then(
				res => {
					if ((cantidad + 100) < dataConvert.length) {
						cantidad_insertados += res.cantidad_insertados;
						localsnack.open(`En Proceso: Se han insertado ${(cantidad + 100)} Cliente(s).`, 'Cerrar', { duration: 3000, });
						sendLista(cantidad + 100, gatew, idcampana, localspinner, localsnack, urlfinal, nombrearchivo, totaldatos, this2)
					} else {
						cantidad_insertados += res.cantidad_insertados;
						// localsnack.open(`Finalizado: Han sido cargados ${cantfin} gestione(s) con éxito de ${cantini}.`, 'Cerrar', { duration: 7000, });
						localsnack.open(`Finalizado: Han sido cargados ${cantidad_insertados} gestione(s) con éxito de ${cantini}.`, 'Cerrar', { duration: 7000, });
						localspinner.hide();
					}
				},

				err => {
					localsnack.open('ERROR: las gestiones no han sido cargadas, intente nuevamente.', 'Cerrar', { duration: 3000, });
					localspinner.hide();
					// console.log(err);
				}
			);

		}
	}

	convertirArreglo(data, keys) {
		// let keys = data.splice(0, 1)[0];
		// console.log(keys);
		let ret = [];
		try {
			data.forEach(element => {
				const obj: any = {};
				for (let index = 0; index < element.length; index++) {
					let aux: string = keys[index];
					aux = aux.replace('"', '').trim();
					aux = aux.toString().replace(/'/g, "");
					obj[aux] = element[index];
					// obj[aux] = obj[aux] ? this.excelDateToJSDate(aux, obj[aux]) : obj[aux]
					obj[aux] = obj[aux] ? this.excelDateToJSDate1(aux, obj[aux]) : obj[aux]
				}
				if (obj.phone_number) {
					let str = obj.phone_number;
					if (!isNaN(str)) {
						obj._IDTELEFONOCAMPANA = `${obj.phone_number}${obj.cc_campaign_id}`;
						ret.push(obj);
					}
				}
			});
			if (ret.length && (ret[0].phone_number && ret[0].cc_campaign_id)) {
				return ret;
			} else {
				this.snackbar.open('Archivo no válido, Las columnas phone_number y cc_campaign_id son obligatorias.', 'Cerrar', { duration: 3000, });
				return [];
			}
		} catch (e) {
			this.spinner.hide();
			this.snackbar.open('Archivo no válido intente de nuevo.', 'Cerrar', { duration: 3000, });
			return null;
		}
	}

	excelDateToJSDate(aux, excelDate) {
		if (aux == 'call_start_dt' || aux == 'call_end_dt' || aux == 'open_dt' || aux == 'failed_dt' || aux == 'received_dt' || aux == 'dt' || aux == 'reschedule_dt') {
			const date = new Date(1900, 0, excelDate - 1);  // Ajuste para el día base de Excel
			const days = Math.floor(excelDate);
			const secondsInDay = (excelDate - days) * 86400; // 86400 segundos en un día
			date.setSeconds(secondsInDay);
			let strdate = `${date.getFullYear()}-${this.dosDig(date.getMonth() + 1)}-${this.dosDig(date.getDate())} ${this.dosDig(date.getHours())}:${this.dosDig(date.getMinutes())}:${this.dosDig(date.getSeconds())}`
			return strdate;
		}
		return excelDate;
	}

	excelDateToJSDate1(aux, excelDate) {
		if (aux == 'call_start_dt' || aux == 'call_end_dt' || aux == 'open_dt' || aux == 'failed_dt' || aux == 'received_dt' || aux == 'dt' || aux == 'reschedule_dt') {

			const moment = require('moment');
			// Fecha en formato "DD/MM/YYYY hh:mm:ss"
			const fechaOriginal = excelDate;
			// Convertir al formato "YYYY-MM-DD hh:mm:ss"
			const fechaConvertida = moment(fechaOriginal, "DD/MM/YYYY hh:mm:ss").format("YYYY-MM-DD HH:mm:ss");
			// const fechaConvertida = moment(fechaOriginal, "MM/DD/YYYY hh:mm:ss").format("YYYY-MM-DD HH:mm:ss");
			return fechaConvertida;
		}
		return excelDate;
	}

	dosDig(num) {
		return num < 10 ? `0${num}` : num;
	}

	// =================================================================================================================
	// =================================================================================================================

	duplicar(campana) {
		// const dialogRef = this.dialog.open(DuplicarCampanaComponent, {
		// 	disableClose: true,
		// 	width: '450px',
		// 	data: campana
		// });

		// dialogRef.afterClosed().subscribe(() => {
		// 	this.get(this.actpage);
		// });
	}

	prepararinformacion(campana, count, index, data) {
		this.gateway.get('exportarlistaadminlote', { IDCAMPANA: campana.idcampana, LIMIT: 100, OFFSET: index }).then(
			(result: any) => {
				if (data) {
					data = data.concat(result.rows)
				} else {
					data = result.rows;
				}
				let control = index + 100;
				if (control <= count) {
					this.prepararinformacion(campana, count, control, data);
				} else {
					this.descargarexcel(data, campana);
				}
			}
		);
	}

	descargarexcel(ctr, campana) {
		const fileName = 'Campana' + campana.nombre + '-' + Date.now();
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(ctr);
		XLSX.utils.book_append_sheet(wb, ws);

		const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
		saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
		this.spinner.hide();
	}

	public async openPassword() {
		const agente = this.localSave.get('usuarioPGV');
		let dialogRef = await this.dialog.open(PasswordnewComponent, {
			width: '450px',
			disableClose: true,
			data: { title: 'Cambio de contraseña', agente: { idagente: agente.IDU } }
		});

		dialogRef.afterClosed().subscribe(result => {
		});
	}

	//----------------ASIGNA MASIVO------------------

	asignaMasivo() {
		document.getElementById("uploadfileasigna").click();
	}

	onFileChangeAsigna(evt: any) {
		let LISTA = [];

		this.spinner.show();

		let uploadname = evt.target.value.split('\\')[evt.target.value.split('\\').length - 1];

		// console.log(uploadname);

		/*    this.openclose=false;*/
		/* wire up file reader */
		const target: DataTransfer = <DataTransfer>(evt.target);
		if (target.files.length !== 1) throw new Error('Cannot use multiple files');
		const reader: FileReader = new FileReader();
		reader.onload = (e: any) => {
			/* read workbook */
			const bstr: string = e.target.result;
			const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

			/* grab first sheet */
			const wsname: string = wb.SheetNames[0];
			const ws: XLSX.WorkSheet = wb.Sheets[wsname];
			/* save data */
			const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
			(<HTMLInputElement>document.getElementById('uploadfileasigna')).value = null;
			// console.log(dataexcel);
			let csv = [];
			const flag = dataexcel[0];
			const bandera: number = 0;

			//validar columnas

			if (flag[0] === 'USUARIO' && flag[1] === 'CAMPAÑA' && flag[2] === 'CONTACTO' && flag[3] === 'EFECTIVIDAD'
				&& flag[4] === 'CONVERSION' && flag[5] === 'TMO(SEG)' && flag[6] === 'LLAMADAS' && flag[7] === 'CONTACTOS EFECTIVOS') {
				dataexcel.forEach((value) => {
					if (value[0] != 'USUARIO' && value[0] != '' && value[0] != undefined
						&& value[1] != 'CAMPAÑA' && value[1] != '' && value[1] != undefined
						&& value[2] != 'CONTACTO' && value[2] != '' && value[2] != undefined
						&& value[3] != 'EFECTIVIDAD' && value[3] != '' && value[3] != undefined
						&& value[4] != 'CONVERSION' && value[4] != '' && value[4] != undefined
						&& value[5] != 'TMO(SEG)' && value[5] != '' && value[5] != undefined
						&& value[6] != 'LLAMADAS' && value[6] != '' && value[6] != undefined
						&& value[7] != 'CONTACTOS EFECTIVOS' && value[7] != '' && value[7] != undefined) {
						LISTA.push({
							USUARIO: value[0], CAMPANA: value[1], CONTACTO: value[2], EFECTIVIDAD: value[3]
							, CONVERSION: value[4], TMO: value[5], LLAMADAS: value[6], CONTACTOS: value[7]
						});
					}
				});
				this.loadlistxlsAsigna(LISTA, 0);
			} else {
				this.snackbar.open('Formato de archivo no válido, porfavor intente con otro archivo.', 'CERRAR', { duration: 6000 });
				this.spinner.hide();
			}
		};
		reader.readAsBinaryString(target.files[0]);
	}

	loadlistxlsAsigna(LISTA, cantidad) {
		this.spinner.show();
		let auxarr = [];
		auxarr = LISTA.slice(cantidad, cantidad + 300);
		this.gateway.save('asignamasivaagentes', { IDCAMPANA: 10, LISTA: auxarr, IDADMINISTRADOR: this.localSave.get('usuarioPGV').IDU, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then(
			res => {
				const resultado: any = res;
				if ((cantidad + 300) < LISTA.length) {
					this.loadlistxlsAsigna(LISTA, cantidad + 300);
				} else {
					this.spinner.hide();
					this.snackbar.open('Campañas asignadas con éxito: ' + resultado.agregados + ', campañas no asignadas: ' + resultado.noagregados, 'Cerrar', { duration: 5000, });
					this.get(this.actpage);
				}
			},
			err => {
				this.spinner.hide();
				this.snackbar.open('Los agentes no han sido asignados, intente nuevamente.', 'Cerrar', { duration: 5000, });
				// console.log(err);
			}
		);
	}

}

export interface Campana {
	ID_EJE: number,
	ID_CAMPANA: number,
	NOMBRE: string,
	NOMBREEJE: string,
	ESTADO: number,
	MEDIO: string,
	FECHAINICIAL: string,
	FECHAFINAL: string,
	SCRIPT: string,
	SCRIPTURL: string
}
